import type { AppDispatch } from "@litres-core/store";
import { api, searchApi } from "@litres-core/store";
import { SearchResponseItemTypesEnum } from "@litres-libs/types";
import { useDispatch } from "react-redux";

export interface Api {
  getSearchData: (query: string) => void;
  getSearchHistory: (limit: [number, number]) => void;
  saveSearchQuery: (query: string) => void;
  refreshSearchResults: () => void;
  clearSearchHistory: () => void;
  showNotificationsPopup: (visibility: boolean) => void;
}

const searchType = SearchResponseItemTypesEnum.all;

export const useApi = (): Api => {
  const dispatch = useDispatch<AppDispatch>();

  // Search Slice
  const getSearchData = (query: string): void => {
    dispatch(
      searchApi.endpoints.getSearch.initiate({
        q: query,
        types: [searchType],
      })
    );
  };
  const getSearchHistory = (limit: [number, number]): void => {
    dispatch(api.global.search.getSearchHistory({ limit }));
  };
  const saveSearchQuery = (query: string): void => {
    dispatch(api.global.search.saveSearchQuery({ query }));
  };
  const refreshSearchResults = (): void => {
    dispatch(api.global.search.refreshSearchResults());
  };
  const clearSearchHistory = (): void => {
    dispatch(api.global.search.clearSearchHistory({}));
  };

  // Notifications
  const showNotificationsPopup = (visibility: boolean): void => {
    dispatch(
      api.global.interfaceRequests.setSpamTicketsConfig({ isOpen: visibility })
    );
  };

  return {
    getSearchData,
    getSearchHistory,
    saveSearchQuery,
    refreshSearchResults,
    clearSearchHistory,
    showNotificationsPopup,
  };
};
